import {makeKey,update} from '../../../../utils/reducerOperations';
export function addOrganizationStarted(state, payload) {
    return makeKey(
        'addOrganizationApi',
        update(state.addOrganizationApi, {isProcessing: true})
    );
}